import { RootStore } from "./rootStore";
import { observable, action } from "mobx";

export default class ModalStore {
  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @observable title: string | null = null;

  @observable.shallow modal = {
    open: false,
    body: null,
    size: 'mini',
    closeOnEscape: true
  };

  @action openModal = (content: any, size?: string) => {
    this.modal.open = true;
    this.modal.body = content;
    this.modal.size = size ? size! : 'mini'
  };

  @action closeModal = () => {
    this.modal.open = false;
    this.modal.body = null;
  };
}
